module.exports = __webpack_public_path__ + "static/media/zm.cda1574f.jpeg";